import React, { useRef, useEffect } from "react";
import * as echarts from "echarts";

const StatusByDateChart = ({ chartOption }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (chartRef.current) {
      chartInstance.current = echarts.init(chartRef.current);
      chartInstance.current.setOption(chartOption);

      const handleResize = () => {
        chartInstance.current?.resize();
      };
      window.addEventListener("resize", handleResize);

      return () => {
        chartInstance.current?.dispose();
        window.removeEventListener("resize", handleResize);
      };
    }
  }, [chartOption]);

  return (
    <div className="border border-green-100 rounded-lg p-3">
      <h2 className="text-base whitespace-nowrap w-fit m-0 mb-3">
        Orders By Date and Status
      </h2>
      <div
        ref={chartRef}
        style={{ width: "100%", height: "450px" }}
        id="statusByDateChart"
      />
    </div>
  );
};

export default StatusByDateChart;
